import React from "react";
import {
  List,
  Datagrid,
  TextField,
  ShowButton,
  EditButton,
  ReferenceField,
} from "react-admin";
import ListPagination from "../../components/ListPagination";
import ConfirmBulkActions from "../../components/ConfirmBulkActions";
import { perPage } from "../../defaults/Defaults";
import WebhookTriggerChips from "../../components/Webhook/WebhookTriggerChips";

const WebhookList = (props) => {
  /*
        TO DO:
        - [] Add missing fields       
    */

  return (
    <List
      {...props}
      bulkActionButtons={<ConfirmBulkActions />}
      perPage={perPage}
      pagination={<ListPagination />}
      title="webhooks"
    >
      <Datagrid>
        <TextField source="id" />
        <TextField source="destination" />
        <WebhookTriggerChips label="Event Types" />
        <ReferenceField
          label="Organization"
          source="org_id"
          reference="organizations"
          link="show"
        >
          <TextField source="name" />
        </ReferenceField>
        <ShowButton />
        <EditButton />
      </Datagrid>
    </List>
  );
};

export default WebhookList;
